import { Component, HostBinding, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { IMfaValidationResponse } from '../../models/mfa-validation-response.interface';

@Component({
    selector: 'upsc-view-access-point-code-dialog',
    templateUrl: './view-access-point-code-dialog.component.html',
    styleUrls: ['./view-access-point-code-dialog.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        MatDialogClose,
        MatButtonModule,
        TranslateModule,
    ],
})
export class ViewAccessPointCodeDialogComponent {
    @HostBinding('class') public hostClass = 'view-access-point-code-dialog';

    public constructor(public dialogRef: MatDialogRef<ViewAccessPointCodeDialogComponent>,
                       @Inject(MAT_DIALOG_DATA) public data: IMfaValidationResponse,
    ) {
    }
}
